'use strict';

angular.module('far.models.mountains.regions', [])
.service('mountainRegions', function($log, $http) {
	var list = [],
		firstListQuery = true,
		listQueryProgress = false,
		addBlank = false;

	Object.defineProperty(this, 'list', {
		get: function() {
			if (firstListQuery && !listQueryProgress) {
				listQueryProgress = true;

				$http.get(Routing.generate('api_entities_get_mountainregions'))
					.then(function(response) {

                        response.data.sort(function(a, b) {
                            return parseInt(a.name) - parseInt(b.name);
                        });

						response.data.forEach(function(regionData) {
							list.push(new MountainRegion(regionData));
						});

						firstListQuery = false;
						listQueryProgress = false;
					})
					.catch(function(response) {
						listQueryProgress = false;
						$log.error(response);
					});
			}

			return list;
		}
	});

    this.setAddBlank = function(value) {
        addBlank = value;
    };

	this.new = function(regionData) {
		return new MountainRegion(regionData);
	};

	this.delete = function(region, callback) {
		return $http.delete(Routing.generate('api_entities_delete_mountainregion', {mountainRegion: region.id}))
				.then(function() {
					region = null;

					if (typeof callback == 'function') {
						callback();
					}
				})
				.catch(function(response) {
					$log.error(response);
				});
	};

	this.restore = function(region, callback) {
		return $http.patch(Routing.generate('api_entities_patch_mountainregion', {id: region.id}))
            .then(function() {
                    if (typeof callback == 'function') {
                        callback();
                    }
				})
				.catch(function(response) {
					$log.error(response);
				});
	};

	this.get = function(regionId, callback) {
		var region = new MountainRegion({});

		$http.get(Routing.generate('api_entities_get_mountainregion', {mountainRegion: regionId}))
			.then(function(response) {
				region = region.update(response.data);

				if (typeof callback == 'function') {
					callback();
				}
			})
			.catch(function(response) {
				$log.error(response);
			});

		return region;
	};

	function MountainRegion(regionData) {
		var areas = [],
			firstAreasQuery = true,
			areasQueryProgress = false;

		angular.merge(this, regionData);

		if (angular.isUndefined(this.mountain_areas)) {
			Object.defineProperty(this, 'mountain_areas', {
				enumerable: true,
				set: function(data) {
					if (angular.isArray(data)) {
						data.forEach(function(area) {
							areas.push(area);
						});
					}
				},
				get: function() {
					if (firstAreasQuery && !areasQueryProgress && angular.isDefined(this.id)) {
						areasQueryProgress = true;

						$http.get(Routing.generate('api_entities_get_mountainarea', {mountainRegion: this.id}))
							.then(function(response) {
								// Мы еще не получили информации о районах
								if ( areas.length == 0 && response.data.length ) {
                                    if (addBlank == true) {
                                        // Пункт для очистки выпадающего списка
                                        areas.push({
                                            id: 0,
                                            name: '...'
                                        });
                                    }
									response.data.forEach(function(area) {
										areas.push(area);
									});
								}

								firstAreasQuery = false;
								areasQueryProgress = false;
							})
							.catch(function(response) {
								areasQueryProgress = false;
								$log.error(response);
							});
					}

					return areas;
				}
			});
		}

		Object.defineProperty(this, 'update', {
			enumerable: false,
			get: function() {
				return function(regionData) {
					angular.merge(this, regionData);
				}
			}
		});

		Object.defineProperty(this, 'save', {
			enumerable: false,
			get: function() {
				return function() {
					// TODO: Rest API url
					var method = this.id ? 'put' : 'post',
						url = this.id ?
							Routing.generate('api_entities_put_mountainregion', {mountainRegion: this.id}) :
							Routing.generate('api_entities_post_mountainregion');

					return $http[method](url, this);
				}
			}
		});
	}
});
